Wee.fn.make('jppNewsletter', {
	init: function() {
		var	scope = this,
			results = [],
			rules = [
				[
					'.js-first-name',
					'required'
				],
				[
					'.js-last-name',
					'required'
				],
				[
					'.js-email',
					'required|email'
				],
				[
					'.js-email-confirm',
					'required|email|confirm:js-email'
				]
			];

		Wee.modal.init();
		Wee.infieldLabels.init();

		// Commented out until/unless they want to show it again
		// $('ref:promoOverlay').show();

		$.events.on({
			'ref:promoClose': {
				click: function() {
					$('ref:promoOverlay').hide();
				}
			},
			'ref:jppNewsletterInput': {
				keyup: function(e) {
					if (e.key === 'Enter') {
						var $email = $('ref:jppNewsletterEmail');

						if ($email.val() === '') {
							$email.val($('ref:jppNewsletterInput').val());
						}

						Wee.modal.toggle();
					}
				}
			},
			'ref:modalToggle': {
				click: function() {
					var $email = $('ref:jppNewsletterEmail');

					if ($email.val() === '') {
						$email.val($('ref:jppNewsletterInput').val());
					}
				}
			},
			'ref:jppNewsletterForm': {
				submit: function(e, el) {
					var $form = $form;

					results = Wee.validate.run(rules);

					$('.form-input-error').hide();
					$('.js-modal-input').removeClass('-has-error');

					if (! results.length) {
						scope.submitForm(el);
					} else {
						for (var i = 0; i < results.length; i++) {
							var modifier = '-' + results[i][1] + '-error';

							$(results[i][0] + modifier).show();
							$(results[i][0]).addClass('-has-error');
						}
					}

					e.preventDefault();
				}
			}
		});
	},

	submitForm: function(el) {
		var scope = this,
			$form = $(el);

		scope.disableButton();

		$.fetch.request({
			url: $form.attr('action'),
			method: 'post',
			data: $form.serialize(),
			type: 'text',
			success: function() {
				scope.showSuccessMessage();

				// Enable button
				scope.enableButton();
			},
			error: function() {
				$('ref:newsletterGlobalError').text('There was a problem submitting your form');

				// Enable button
				scope.enableButton();
			}
		});

		setTimeout(function() {
			scope.enableButton();
		}, 5000);
	},

	disableButton: function() {
		$('ref:registerButton').prop('disabled', true)
			.text('Submitting...');
	},

	enableButton: function() {
		$('ref:registerButton').prop('disabled', false)
				.text('Submit');
	},

	showSuccessMessage: function() {
		Wee.modal.close();

		$('ref:newsletter').html(
			$.view.render('newsletter-thank', {
				heading: 'Thanks for signing up!',
				body: $.get('thankYouBody')
			}
		));
	}
});

Wee.fn.make('jppIndex', {
	init: function() {
		var $hero = $('ref:hero');

		$.screen.map([
			{
				max: 1,
				callback: function() {
					$hero.css('background-image', 'url(' + $hero.data('mobile-bg') + ')');
				}
			},
			{
				min: 2,
				max: 3,
				callback: function() {
					$hero.css('background-image', 'url(' + $hero.data('tablet-bg') + ')');
				}
			},
			{
				min: 4,
				callback: function() {
					$hero.css('background-image', 'url(' + $hero.data('desktop-bg') + ')');
				}
			}
		]);
	}
});

$.routes.map({
	'$any': [
		'jppIndex',
		'jppNewsletter'
	]
});